import React from 'react';

import background from 'assets/themes/default/background.jpg';
import logo from 'assets/themes/default/logo.png';

const TemplateAuth = ({ children }) => {
  return (
    <div>
      <div
        className="auth-container__background"
        style={{ backgroundImage: `url('${background}')` }}
      />
      <div className="auth-container__foreground">
        <div
          className="_flex:row _flex:align(center) _p:x(4) _shadow(2)"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            height: '3rem',
            backgroundColor: 'var(--white)',
          }}
        >
          <div style={{ height: '1.8rem' }}>
            <img src={logo} height="100%" alt="logo" />
          </div>
        </div>
        <div className="auth-container__content">{children}</div>
      </div>
    </div>
  );
};

export default TemplateAuth;
